import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaMedal, FaFileDownload } from 'react-icons/fa';
import Seo from '../components/Seo';

function Results() {
  const [selectedSession, setSelectedSession] = useState('combined');

  // Session 1 Results
  const session1Female = {
    '9 & Under': [
      { name: 'Anja RATCLIFFE', points: 8 },
      { name: 'Edith MARSLAND', points: 8 },
      { name: 'Mila MCCORD', points: 8 }
    ],
    '10-11': [
      { name: 'Lyla MCCRACKEN', points: 11 },
      { name: 'Adeline NELSON', points: 9 },
      { name: 'Francesca WOOTTON', points: 8 },
      { name: 'Clara DUNCAN', points: 5 },
      { name: 'Alice NICHOLSON', points: 1 },
      { name: 'Neve WARD', points: 1 },
      { name: 'Lucia GIFFORD', points: 0 },
      { name: 'Florence SANDOVER', points: 0 },
      { name: 'Bethany DAVIE', points: 0 }
    ],
    '12-13': [
      { name: 'Liesel NELSON', points: 15 },
      { name: 'Isla WOOTTON', points: 12 },
      { name: 'Nia REES', points: 8 },
      { name: 'Hattie WARD', points: 5 },
      { name: 'Charlotte WOOTTON', points: 3 },
      { name: 'Isabelle PAYNE', points: 1 },
      { name: 'Amelie FOX', points: 0 }
    ],
    '14-15': [
      { name: 'Ellie SPENCER', points: 15 },
      { name: 'Grace HILL', points: 8 },
      { name: 'Lily FAIRHURST', points: 7 },
      { name: 'Fia-Marie GATENBY', points: 6 },
      { name: 'Emily FURMSTON', points: 4 },
      { name: 'Lucy BAUGH', points: 3 },
      { name: 'Esther HARRIS', points: 2 },
      { name: 'Freya FOX', points: 0 }
    ],
    '16+': [
      { name: 'Mia ALLEN', points: 10 },
      { name: 'Ruby HANNON', points: 9 },
      { name: 'Emily MCGILL', points: 8 },
      { name: 'Rose ALLEN', points: 8 },
      { name: 'Ella MEANWELL', points: 4 }
    ]
  };

  const session1Male = {
    '9 & Under': [
      { name: 'Sebastian CHORLTON', points: 8 },
      { name: 'Haden BYROM', points: 5 },
      { name: 'Findlay MERCER', points: 4 }
    ],
    '10-11': [
      { name: 'Isaac PAYNE', points: 15 }
    ],
    '12-13': [
      { name: 'Quinn COLLIER', points: 15 },
      { name: 'Isaac CHRIPPES', points: 8 },
      { name: 'Sam COLLIER', points: 7 },
      { name: 'Max MCHUGH', points: 2 }
    ],
    '14-15': [
      { name: 'Harry CHEADLE', points: 14 },
      { name: 'Ben GAULD', points: 13 },
      { name: 'Charlie WENTWORTH-WALK', points: 5 },
      { name: 'Ethan HORTON', points: 3 }
    ],
    '16+': [
      { name: 'Harry BAUGH', points: 15 }
    ]
  };

  // Session 2 Results
  const session2Female = {
    '9 & Under': [
      { name: 'Anja RATCLIFFE', points: 10 },
      { name: 'Mila MCCORD', points: 7 },
      { name: 'Edith MARSLAND', points: 7 }
    ],
    '10-11': [
      { name: 'Francesca WOOTTON', points: 10 },
      { name: 'Lyla MCCRACKEN', points: 8 },
      { name: 'Alice NICHOLSON', points: 5 },
      { name: 'Florence SANDOVER', points: 3 },
      { name: 'Lucia GIFFORD', points: 3 }
    ],
    '12-13': [
      { name: 'Liesel NELSON', points: 10 },
      { name: 'Isla WOOTTON', points: 8 },
      { name: 'Nia REES', points: 5 },
      { name: 'Hattie WARD', points: 5 },
      { name: 'Charlotte WOOTTON', points: 2 },
      { name: 'Isabelle PAYNE', points: 0 },
      { name: 'Amelie FOX', points: 0 }
    ],
    '14-15': [
      { name: 'Fia-Marie GATENBY', points: 10 },
      { name: 'Ellie SPENCER', points: 8 },
      { name: 'Lily FAIRHURST', points: 5 },
      { name: 'Emily FURMSTON', points: 5 },
      { name: 'Grace HILL', points: 2 },
      { name: 'Lucy BAUGH', points: 0 },
      { name: 'Freya FOX', points: 0 },
      { name: 'Esther HARRIS', points: 0 }
    ],
    '16+': [
      { name: 'Emily MCGILL', points: 9 },
      { name: 'Ruby HANNON', points: 7 },
      { name: 'Rose ALLEN', points: 6 },
      { name: 'Mia ALLEN', points: 4 },
      { name: 'Ella MEANWELL', points: 1 }
    ]
  };

  const session2Male = {
    '9 & Under': [
      { name: 'Haden BYROM', points: 10 },
      { name: 'Findlay MERCER', points: 8 },
      { name: 'Sebastian CHORLTON', points: 6 }
    ],
    '10-11': [
      { name: 'Isaac PAYNE', points: 10 }
    ],
    '12-13': [
      { name: 'Quinn COLLIER', points: 9 },
      { name: 'Sam COLLIER', points: 6 },
      { name: 'Max MCHUGH', points: 6 },
      { name: 'Isaac CHRIPPES', points: 5 },
      { name: 'Doug COLLIER', points: 1 }
    ],
    '14-15': [
      { name: 'Harry CHEADLE', points: 9 },
      { name: 'Ben GAULD', points: 9 },
      { name: 'Ethan HORTON', points: 3 },
      { name: 'Charlie WENTWORTH-WALK', points: 2 }
    ],
    '16+': [
      { name: 'Harry BAUGH', points: 10 }
    ]
  };

  // Combine results
  const combineResults = (session1, session2) => {
    const combined = {};
    const allAgeGroups = new Set([...Object.keys(session1), ...Object.keys(session2)]);

    allAgeGroups.forEach(ageGroup => {
      const swimmers = {};

      (session1[ageGroup] || []).forEach(swimmer => {
        swimmers[swimmer.name] = (swimmers[swimmer.name] || 0) + swimmer.points;
      });

      (session2[ageGroup] || []).forEach(swimmer => {
        swimmers[swimmer.name] = (swimmers[swimmer.name] || 0) + swimmer.points;
      });

      combined[ageGroup] = Object.entries(swimmers)
        .map(([name, points]) => ({ name, points }))
        .sort((a, b) => b.points - a.points);
    });

    return combined;
  };

  const combinedFemale = combineResults(session1Female, session2Female);
  const combinedMale = combineResults(session1Male, session2Male);

  const femaleResults = selectedSession === 'session1' ? session1Female :
                       selectedSession === 'session2' ? session2Female :
                       combinedFemale;

  const maleResults = selectedSession === 'session1' ? session1Male :
                     selectedSession === 'session2' ? session2Male :
                     combinedMale;

  const getRankDisplay = (swimmers, index) => {
    const currentPoints = swimmers[index].points;

    const isJoint = (index > 0 && swimmers[index - 1].points === currentPoints) ||
                    (index < swimmers.length - 1 && swimmers[index + 1].points === currentPoints);

    // Position = 1 + count of swimmers with strictly more points
    let position = 1;
    for (let i = 0; i < index; i++) {
      if (swimmers[i].points > currentPoints) {
        position++;
      }
    }

    const suffix = position === 1 ? 'st' : position === 2 ? 'nd' : position === 3 ? 'rd' : 'th';
    const rankText = isJoint ? `Joint ${position}${suffix}` : `${position}${suffix}`;

    return { rank: position, rankText };
  };

  const medalClass = (rank) => {
    if (rank === 1) return 'bg-amber-400 text-amber-900';
    if (rank === 2) return 'bg-gray-300 text-gray-800';
    if (rank === 3) return 'bg-amber-700 text-amber-50';
    return '';
  };

  const ResultsTable = ({ results, title }) => (
    <div className="mb-12">
      <h3 className="font-display text-2xl font-bold text-navy-900 text-center mb-8">{title}</h3>

      {Object.entries(results).map(([ageGroup, swimmers]) => (
        <div key={ageGroup} className="mb-8">
          <h4 className="text-lg font-bold text-gray-700 mb-3 border-b-2 border-primary-600 pb-2">
            {ageGroup} Age Group
          </h4>

          <div className="bg-white rounded-xl overflow-hidden shadow-md">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-50 border-b-2 border-gray-200">
                  <th className="p-4 text-left font-bold text-gray-700 w-28">Rank</th>
                  <th className="p-4 text-left font-bold text-gray-700">Name</th>
                  <th className="p-4 text-center font-bold text-gray-700 w-24">Points</th>
                </tr>
              </thead>
              <tbody>
                {swimmers.map((swimmer, index) => {
                  const { rank, rankText } = getRankDisplay(swimmers, index);
                  return (
                    <tr
                      key={index}
                      className={`${index < swimmers.length - 1 ? 'border-b border-gray-100' : ''} ${rank <= 3 ? 'bg-amber-50' : ''}`}
                    >
                      <td className="p-4">
                        <span className={`inline-flex items-center gap-2 ${rank <= 3 ? 'font-bold' : ''}`}>
                          {rank <= 3 && (
                            <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs ${medalClass(rank)}`}>
                              <FaMedal />
                            </span>
                          )}
                          {rankText}
                        </span>
                      </td>
                      <td className={`p-4 ${rank <= 3 ? 'font-bold text-navy-900' : 'text-gray-800'}`}>
                        {swimmer.name}
                      </td>
                      <td className="p-4 text-center font-bold text-primary-600">
                        {swimmer.points}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );

  const sessionTabs = [
    { key: 'combined', label: 'Combined Results' },
    { key: 'session1', label: 'Session 1 (Nov 16th)' },
    { key: 'session2', label: 'Session 2 (Nov 23rd)' },
  ];

  return (
    <main className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <Seo
        title="Results"
        description="Gala and competition results for Marple Swimming Club swimmers."
        path="/results"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="font-display text-5xl font-bold text-navy-900 mb-4">Annual Gala Results 2025</h1>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Celebrating the achievements of our swimmers at the MSC Annual Gala
          </p>
        </motion.div>

        {/* Session Selector */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="bg-white rounded-2xl shadow-md p-8 text-center max-w-2xl mx-auto">
            <h2 className="font-display text-2xl font-bold text-navy-900 mb-6">View Results</h2>
            <div className="flex gap-3 justify-center flex-wrap">
              {sessionTabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setSelectedSession(tab.key)}
                  className={`px-5 py-2.5 rounded-full font-semibold border-2 border-primary-600 transition-colors duration-200 ${
                    selectedSession === tab.key
                      ? 'bg-primary-600 text-white'
                      : 'bg-white text-primary-600 hover:bg-primary-50'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <p className="text-gray-600 mt-5">
              Congratulations to all our swimmers who competed!
            </p>
          </div>
        </motion.section>

        {/* Results Tables */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <ResultsTable results={femaleResults} title="Female Standings" />
          <ResultsTable results={maleResults} title="Male Standings" />
        </motion.section>

        {/* Download */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center bg-white rounded-2xl shadow-md p-10"
        >
          <h3 className="font-display text-2xl font-bold text-navy-900 mb-3">Download Full Results</h3>
          <p className="text-gray-700 mb-6">
            Download the complete results with race times and DQ information
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <a
              href="/MSC-Annual-Gala-2025-Session-1-Results.txt"
              download
              className="inline-flex items-center gap-2 bg-primary-600 text-white px-6 py-3 rounded-full font-bold hover:bg-primary-700 transition-all duration-300 shadow-md"
            >
              <FaFileDownload />
              Session 1 Full Results
            </a>
            <a
              href="/MSC-Annual-Gala-2025-Session-2-Results.txt"
              download
              className="inline-flex items-center gap-2 bg-primary-600 text-white px-6 py-3 rounded-full font-bold hover:bg-primary-700 transition-all duration-300 shadow-md"
            >
              <FaFileDownload />
              Session 2 Full Results
            </a>
          </div>
        </motion.section>
      </div>
    </main>
  );
}

export default Results;
